import React from "react";
import "./App.css";
import { Toaster } from "./components/ui/sonner";

import { BrowserRouter, Routes, Route } from "react-router-dom";

import Header from "./components/Header";
import HeroSection from "./components/HeroSection";
import PropertiesSection from "./components/PropertiesSection";
import ServicesSection from "./components/ServicesSection";
import TestimonialsSection from "./components/TestimonialsSection";
import ContactSection from "./components/ContactSection";
import Footer from "./components/Footer";
import PropertiesAdmin from "./components/PropertyAdmin";



function App() {
  return (
    <BrowserRouter>
      <Toaster position="top-right" richColors />

      <Routes>
        {/* 🌐 LANDING */}
        <Route
          path="/"
          element={
            <div className="App">
              <Header />
              <main>
                <HeroSection />
                <PropertiesSection />
                <ServicesSection />
                <TestimonialsSection />
                <ContactSection />
              </main>
              <Footer />
            </div>
          }
        />

        {/* 🔐 ADMIN */}
        <Route path="/admin" element={<PropertiesAdmin />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
